import { InfplBaseProperties } from '../baseProperties';
import { ContactPersoon } from '../contact/contactPerson';

export class InfraPlan extends InfplBaseProperties {
  id: string | null;
  bbox: [number, number, number, number] | null;
  planId?: string | null;
  planNaam: string | null;
  planOmschrijving: string | null;
  planNummer: string | null;
  infplOrganizationId: string | null;
  infplOrganizationName: string | null;
  classificatie: string | null;
  status: string | null;
  discipline: string | null;
  typeWerk: string | null;
  startDatum: string | null;
  eindDatum: string | null;
  kosten: number | null;
  aanmaakDatum: string | null;
  laatstGewijzigd: string | null;
  gereedDatum: string | null;
  omschrijving: string | null;
  provincieCodes: string[] | null;
  gemeenteCodes: string[] | null;
  wijkCodes: string[] | null;
  buurtCodes: string[] | null;
  waterschappenCodes: string[] | null;
  netbeheerderCodes: string[] | null;
  labels: string[] | null;
  contactPersonen: ContactPersoon[] | null;
  geoJson: string | null;
  colorRgb: string | null;
  colorRgba: string | null;
  beoordelingen: any[] | null;
  
  constructor() {
    super();
    this.id = null;
    this.bbox = null;
    this.planId = null;
    this.planNaam = null;
    this.planOmschrijving = null;
    this.planNummer = null;
    this.infplOrganizationId = null;
    this.infplOrganizationName = null;
    this.classificatie = null;
    this.status = null;
    this.discipline = null;
    this.typeWerk = null;
    this.startDatum = null;
    this.eindDatum = null;
    this.kosten = null;
    this.aanmaakDatum = null;
    this.laatstGewijzigd = null;
    this.gereedDatum = null;
    this.omschrijving = null;
    this.provincieCodes = null;
    this.gemeenteCodes = null;
    this.wijkCodes = null;
    this.buurtCodes = null;
    this.waterschappenCodes = null;
    this.netbeheerderCodes = null;
    this.labels = null;
    this.contactPersonen = null;
    this.geoJson = null;
    this.colorRgb = null;
    this.colorRgba = null;
    this.beoordelingen = null;
  }
}
